import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// import { isMobile } from '../../../utils/constants';
import { UsefulWidgetLeft, ServiceApartment, HeadUseful } from '../common/index';
import { history } from '../../../utils/history';
import { getPathLanguage, getQueryString } from '../../../utils/params';
import { getDetailTopic, getDistricts, getTopics } from '../usefulPage.api';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import { useParams } from 'react-router-dom';

const UsefulPageComponent = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const location = useLocation();
  const { language } = useParams();
  const pathLanguage = getPathLanguage(location);
  const [topicActive, setTopicActive] = useState(null);
  const [topicsApartment, setTopicsApartment] = useState(null);
  const [listArea, setListArea] = useState(null);
  const [detailTopic, setDetailTopic] = useState(null);

  useEffect(() => {
    showLoader();
    getTopics(getQueryString({ language, takeNumber: 999 })).then(res => {
      if (res) {
        setTopicsApartment(res);
      }
    });
    hideLoader();
    //eslint-disable-next-line
  }, [language]);

  useEffect(() => {
    showLoader();
    if (topicsApartment && topicsApartment.length) {
      topicsApartment
        .sort(({ id: a }, { id: b }) => a - b)
        .forEach(item => {
          if (location.pathname.includes(item.slug)) {
            setTopicActive(item);
          }
        });
    }
    hideLoader();
    // eslint-disable-next-line
  }, [topicsApartment]);

  useEffect(() => {
    if (topicActive) {
      showLoader();
      if (topicActive.slug === 'area-guide') {
        getDistricts(getQueryString({ language })).then(res => {
          if (res) {
            setListArea(res);
          }
        });
      }

      getDetailTopic(getQueryString({ language, id: topicActive.id })).then(res => {
        if (res) {
          setDetailTopic(res);
          hideLoader();
        } else {
          hideLoader();
        }
      });
    }
    // eslint-disable-next-line
  }, [topicActive]);

  const changeTopic = topic => {
    if (topic) {
      setTopicActive(topic);
      history.push(`${pathLanguage}/useful-information/about-renting-an-apartment-office-in-vietnam/${topic.slug}`);
    }
  };

  return (
    <>
      <div>
        <section className="useful-information">
          <HeadUseful />

          <div className="container">
            {topicsApartment && topicsApartment.length ? (
              <div className="row">
                <div className="col-12 col-md-4">
                  <UsefulWidgetLeft changeTopic={changeTopic} topics={topicsApartment} topicActive={topicActive} />
                </div>
                <div className="col-12 col-md-8">
                  <ServiceApartment topicActive={topicActive} detailTopic={detailTopic} listArea={listArea} />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </section>
      </div>
      {loader}
    </>
  );
};

export default UsefulPageComponent;
